import React from 'react'
import Chip from '@mui/material/Chip'

export const MEMBERSHIP_STATUS_CHIP = {
    none: { label: '없음', color: 'default', variant: 'outlined' },
    trial: { label: '무료체험', color: 'info' },
    active: { label: '활성', color: 'success' },
    cancel_scheduled: { label: '해지예정', color: 'warning' },
    cancelScheduled: { label: '해지예정', color: 'warning' },
    grace: { label: '유예', color: 'warning' },
    paymentIssue: { label: '결제확인', color: 'warning' },
    expired: { label: '만료', color: 'default' },
    refunded: { label: '환불', color: 'error' },
    revoked: { label: '회수', color: 'error' },
}

export const ORDER_CLAIM_STATUS_CHIP = {
    1: { label: '접수', color: 'warning' },
    2: { label: '처리중', color: 'info' },
    3: { label: '완료', color: 'success' },
    4: { label: '반려', color: 'error' },
}

export const PAYMENT_STATUS_CHIP = {
    paid: { label: '결제', color: 'success' },
    cancelled: { label: '취소', color: 'warning' },
}

export const SHIPPING_STATUS_CHIP = {
    1: { label: '상품준비중', color: 'default', variant: 'outlined' },
    2: { label: '배송중', color: 'info' },
    3: { label: '배송완료', color: 'success' },
}

export const QNA_ANSWER_STATUS_CHIP = {
    0: { label: '미답변', color: 'warning' },
    1: { label: '답변', color: 'success' },
}

export const ADMIN_STATUS_CHIP = {
    0: { label: '거부', color: 'error' },
    1: { label: '승인', color: 'success' },
}

export default function StatusChip({
    status,
    config,
    label,
    color,
    variant,
    size = 'small',
    fallbackLabel = '-',
    ...props
}) {
    const statusConfig = config ? config[status] : null
    const chipLabel = label ?? statusConfig?.label ?? status ?? fallbackLabel

    return (
        <Chip
            size={size}
            label={chipLabel || fallbackLabel}
            color={color ?? statusConfig?.color ?? 'default'}
            variant={variant ?? statusConfig?.variant ?? 'filled'}
            {...props}
        />
    )
}
